if (!customElements.get('shop-the-looks')) {
  customElements.define(
    'shop-the-looks',
    class ShopTheLooks extends HTMLElement {
      connectedCallback() {
        this.looks = Array.from(this.querySelectorAll('.js-stl-look'));
        this.looks.forEach((look) => this.initLook(look));
      }

      initLook(look) {
        const products = Array.from(look.querySelectorAll('.js-stl-product'));
        const button = look.querySelector('.js-stl-add-look');
        const status = look.querySelector('.js-stl-status');
        const productsTrack = look.querySelector('.js-stl-products-track');
        const prevButton = look.querySelector('.js-stl-products-prev');
        const nextButton = look.querySelector('.js-stl-products-next');

        products.forEach((productCard) => {
          const variantsNode = productCard.querySelector('.js-stl-variants');
          productCard._variants = this.readVariants(variantsNode);
          const selects = Array.from(productCard.querySelectorAll('.js-stl-option'));
          selects.forEach((select) => {
            select.addEventListener('change', () => {
              this.syncSelectedVariant(productCard);
              this.updateLookTotal(look);
            });
          });
          this.syncSelectedVariant(productCard);
        });

        this.updateLookTotal(look);
        this.bindProductsSlider(productsTrack, prevButton, nextButton);

        if (button) {
          button.addEventListener('click', async () => {
            await this.addLookToCart(look, button, status);
          });
        }
      }

      bindProductsSlider(track, prevButton, nextButton) {
        if (!track || !prevButton || !nextButton) return;

        const getStep = () => {
          const firstCard = track.querySelector('.js-stl-product');
          if (!firstCard) return track.clientWidth * 0.5;
          const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
          return firstCard.getBoundingClientRect().width + gap;
        };

        prevButton.addEventListener('click', () => {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        nextButton.addEventListener('click', () => {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      readVariants(variantsNode) {
        if (!variantsNode) return [];
        try {
          const parsed = JSON.parse(variantsNode.textContent);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.error('Shop the looks: variants JSON invalid', error);
          return [];
        }
      }

      syncSelectedVariant(productCard) {
        const variants = productCard._variants || [];
        if (!variants.length) return;

        const selectedOptions = [1, 2, 3].map((position) => {
          const select = productCard.querySelector(`.js-stl-option[data-option-position="${position}"]`);
          return select ? select.value : null;
        });

        let matchedVariant = variants.find((variant) => {
          return (
            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
            (!selectedOptions[1] || variant.option2 === selectedOptions[1]) &&
            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
            variant.available
          );
        });

        if (!matchedVariant) {
          matchedVariant = variants.find((variant) => variant.available) || variants[0];
        }

        if (!matchedVariant) return;

        productCard.dataset.selectedVariantId = matchedVariant.id;
        productCard.dataset.selectedVariantPrice = matchedVariant.price;

        const priceNode = productCard.querySelector('.js-stl-price');
        if (priceNode) {
          const amount = (matchedVariant.price || 0) / 100;
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
          priceNode.textContent = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency,
          }).format(amount);
        }
      }

      updateLookTotal(look) {
        const totalNode = look.querySelector('.js-stl-total');
        if (!totalNode) return;

        const cards = Array.from(look.querySelectorAll('.js-stl-product'));
        const totalCents = cards.reduce((acc, card) => acc + (parseInt(card.dataset.selectedVariantPrice || '0', 10) || 0), 0);

        totalNode.dataset.totalCents = String(totalCents);
        const amount = totalCents / 100;
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        totalNode.textContent = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
        }).format(amount);
      }

      async addLookToCart(look, button, statusNode) {
        const cards = Array.from(look.querySelectorAll('.js-stl-product'));
        const itemsMap = new Map();

        cards.forEach((card) => {
          const variantId = parseInt(card.dataset.selectedVariantId || '0', 10);
          if (!variantId) return;
          const currentQty = itemsMap.get(variantId) || 0;
          itemsMap.set(variantId, currentQty + 1);
        });

        const items = Array.from(itemsMap.entries()).map(([id, quantity]) => ({ id, quantity }));
        if (!items.length) {
          this.setStatus(statusNode, 'Geen beschikbare varianten om toe te voegen.', true);
          return;
        }

        button.setAttribute('disabled', 'disabled');

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const payload = await response.json();

          if (!response.ok || payload.status) {
            throw new Error('Toevoegen aan winkelwagen mislukt.');
          }

          await this.refreshDrawer();
          this.setStatus(statusNode, 'Look toegevoegd aan je winkelwagen.', false);
        } catch (error) {
          console.error(error);
          this.setStatus(statusNode, 'Er ging iets mis. Probeer opnieuw.', true);
        } finally {
          button.removeAttribute('disabled');
        }
      }

      async refreshDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
          window.location.href = window.routes.cart_url;
          return;
        }

        const sections = cartDrawer.getSectionsToRender();
        const sectionIds = sections.map((section) => section.id).join(',');
        const response = await fetch(`${window.routes.cart_url}?sections=${sectionIds}`);
        const parsedSections = await response.json();

        cartDrawer.classList.remove('is-empty');
        const inner = cartDrawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        cartDrawer.renderContents({
          id: Date.now(),
          sections: parsedSections,
        });
      }

      setStatus(statusNode, message, isError) {
        if (!statusNode) return;
        statusNode.textContent = message;
        statusNode.classList.remove('hidden');
        statusNode.style.color = isError ? '' : 'inherit';
      }
    }
  );
}
